import { db } from '../firebase';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  limit,
  startAfter,
  QueryDocumentSnapshot,
} from 'firebase/firestore';
import type { Customer } from '../types/customers';

const CUSTOMERS_COLLECTION = 'customers';

export async function getCustomers(pageSize?: number, lastDoc?: QueryDocumentSnapshot): Promise<{ customers: Customer[]; lastDoc?: QueryDocumentSnapshot }> {
  console.log('[API] getCustomers called');
  const customersRef = collection(db, CUSTOMERS_COLLECTION);
  let q = query(customersRef);
  
  if (pageSize) {
    q = query(q, limit(pageSize));
    if (lastDoc) {
      q = query(q, startAfter(lastDoc));
    }
  }
  
  const snapshot = await getDocs(q);
  const customers = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Customer));
  const newLastDoc = snapshot.docs[snapshot.docs.length - 1];
  
  return {
    customers,
    lastDoc: newLastDoc
  };
}

export async function getCustomerById(id: string): Promise<Customer | null> {
  console.log('[API] getCustomerById called', { id });
  const ref = doc(db, CUSTOMERS_COLLECTION, id);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() } as Customer;
}

export async function addCustomer(customer: Omit<Customer, 'id'>): Promise<string> {
  console.log('[API] addCustomer called', { customer });
  const ref = doc(collection(db, CUSTOMERS_COLLECTION));
  await setDoc(ref, customer);
  return ref.id;
}

export async function updateCustomer(id: string, data: Partial<Customer>): Promise<void> {
  console.log('[API] updateCustomer called', { id, data });
  const ref = doc(db, CUSTOMERS_COLLECTION, id);
  await updateDoc(ref, data);
}

export async function deleteCustomer(id: string): Promise<void> {
  console.log('[API] deleteCustomer called', { id });
  const ref = doc(db, CUSTOMERS_COLLECTION, id);
  await deleteDoc(ref);
}

export async function attachWorkspaceToCustomer(customerId: string): Promise<void> {
  console.log('[API] attachWorkspaceToCustomer called', { customerId });
  // await updateDoc(ref, { workspace });
}

export async function detachWorkspaceFromCustomer(customerId: string): Promise<void> {
  console.log('[API] detachWorkspaceFromCustomer called', { customerId });
  const ref = doc(db, CUSTOMERS_COLLECTION, customerId);
  await updateDoc(ref, { workspace: null });
}

export async function attachPricePlanToCustomer(customerId: string, pricePlanId: string): Promise<void> {
  console.log('[API] attachPricePlanToCustomer called', { customerId, pricePlanId });
  const ref = doc(db, CUSTOMERS_COLLECTION, customerId);
  await updateDoc(ref, { price_plan_id: pricePlanId });
}

export async function detachPricePlanFromCustomer(customerId: string): Promise<void> {
  console.log('[API] detachPricePlanFromCustomer called', { customerId });
  const ref = doc(db, CUSTOMERS_COLLECTION, customerId);
  await updateDoc(ref, { price_plan_id: '' });
} 